import React from 'react'
import ActionPolling from 'atoms/ActionPolling'
import { refetchRequests } from 'actions/requests'

export default () => (
  <ActionPolling
    delay={25000}
    action={refetchRequests}
  />
)
